import React, { useState } from "react";
import { useSelector } from "react-redux";
import AILiteracyAssessmentQuiz from "../components/AILiteracyAssessment/AILiteracyAssessmentQuiz";
import AILiteracyAssessmentDashboard from "../components/AILiteracyAssessment/AILiteracyAssessmentDashboard";

const AILiteracyAssessment = () => {
  const [showQuiz, setShowQuiz] = useState(false);
  const { quizCompleted } = useSelector((state) => state.user);

  const handleStartQuiz = () => {
    setShowQuiz(true);
  };

  const handleQuizComplete = () => {
    setShowQuiz(false);
  };

  // If user is taking the quiz, show quiz component
  if (showQuiz) {
    return <AILiteracyAssessmentQuiz onQuizComplete={handleQuizComplete} />;
  }

  // Otherwise show dashboard component
  return <AILiteracyAssessmentDashboard onStartQuiz={handleStartQuiz} />;
};

export default AILiteracyAssessment;